import React, { Component } from "react";
import { Modal, Tooltip, Select, Form, Button, Input } from 'antd';
import { EditOutlined, } from '@ant-design/icons';
import { isEmptyObject, isUndefined } from "../../../utils/JsObjectHelper";
import AttributeForm from "./AttributeForm";
const { TextArea } = Input;


class EntryEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            method: null,
            event: null,
            values: null,
            entryType: null,
            entryTypesList: null,
            description: '', 
            descriptionError: false, 
        };
    }
    componentDidMount() {
        this.props.onMount();
        if (!isUndefined(this.props.entryTypesRequestResult) && this.props.entryTypesRequestResult.getState().isDone()) {
            let entryTypesList = this.props.entryTypesRequestResult.getData();
            this.setState({ entryTypesList: entryTypesList });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        let activeElement = this.props.activeElement;
        if (activeElement && activeElement.type === 'bpmn:ServiceTask' && !this.state.visible && activeElement.businessObject.delegateExpression === "${entryUpdate}") {
            let value = {};
            let inputParameters = null;
            let entryType = null;
            let arr = Object.entries(this.props.activeElement.businessObject);
            arr.forEach((el) => {
                if (el[0] === 'name') {
                    value.taskName = el[1];
                }
            });
            if (this.props.activeElement.businessObject.extensionElements) {
                inputParameters = this.props.activeElement.businessObject.extensionElements.values[0].inputParameters;
                entryType = this.props.activeElement.businessObject.extensionElements.values[1].value;
            }
            entryType = this.state.entryTypesList.find((el) => entryType === el.type);
            inputParameters.forEach((el) => {
                if (el.name === "entryEdit_Json") {
                    let properties = JSON.parse(el.value).properties;
                    for (let key in properties) {
                        value[key] = properties[key];
                    }
                } else {
                    value[el.name] = el.value;
                }
            });
            console.log(value);
            this.setState({
                entryType: entryType,
                values: value,
                visible: true
            });
        }
    }
    handleCancel = () => {
        this.setState({ visible: false, values: null, entryType: null,description:'',descriptionError:false });
        this.props.clearElement()
    }
    showModal = (event) => {
        this.setState({
            visible: true,
            event: event
        });
    }
    method = (value) => {
        this.setState({
            method: value
        });
    }

    choiceET = (value) => {
        let selectedEt = this.state.entryTypesList.find(el => el.type === value.entryType);
        this.setState({ entryType: selectedEt });
    }
    createTask = (value) => {
        console.log(value);
        const jsonValue = {
            name: value.name,
            description: value.description,
            properties: {}
        };
        for (let key in value) {
            if (value[key] !== undefined &&
                key !== "taskName" &&
                key !== "entryEdit_EntryId" &&
                key !== "status") {
                jsonValue.properties[key] = value[key];
            }
        };
        console.log(jsonValue);
        const modeling = this.props.modeler.get('modeling');
        const bpmnFactory = this.props.modeler.get("bpmnFactory");
        const elementFactory = this.props.modeler.get("elementFactory");
        const create = this.props.modeler.get("create");

        let ServiceTask = bpmnFactory.create('bpmn:ServiceTask');
        ServiceTask.definitionRef = 'modelerTemplate';
        ServiceTask.modelerTemplate = "com.aphinit.bpmn.delegate.EntryUpdate";//Change
        ServiceTask.delegateExpression = "${entryUpdate}";//Change

        let entryId = bpmnFactory.create('camunda:InputParameter', {
            name: "entryEdit_EntryId",
            value: value.entryEdit_EntryId
        });
        let json = bpmnFactory.create('camunda:InputParameter', {
            name: "entryEdit_Json",
            value: JSON.stringify(jsonValue)
        });
        let status = bpmnFactory.create('camunda:InputParameter', {
            name: "entryEdit_Status",
            value: value.entryEdit_Status
        });

        let inputOutput = bpmnFactory.create('camunda:InputOutput', {
            inputParameters: [entryId, json, status],
            outputParameters: []
        });


        let entryTypeProperty = bpmnFactory.create('camunda:Property', {
            name: "entryType",
            value: this.state.entryType.type
        });



        const extensionElements = bpmnFactory.create("bpmn:ExtensionElements");
        extensionElements.set("values", [inputOutput, entryTypeProperty]);
        const serviceTask = elementFactory.createShape({
            type: "bpmn:ServiceTask",
            x: this.state.values ? this.props.activeElement.x + 50 : 0,
            y: this.state.values ? this.props.activeElement.y + 40 : 0,
            isExpanded: true,
            businessObject: ServiceTask
        });
        serviceTask.businessObject.set('name', value.taskName?value.taskName:"Edit "+this.state.entryType.name);
        serviceTask.businessObject.set("extensionElements", extensionElements);
        if (this.state.values) {
            modeling.replaceShape(this.props.activeElement, serviceTask);
            this.props.clearElement();
        }
        else {
            create.start(this.state.event, [serviceTask], {
                hints: {
                    autoSelect: [serviceTask]
                }
            });
        }
        this.setState({
            visible: false, values: null, entryType: null, description:'',descriptionError:false
        });
    };
    handleRelationChanged(values) {
        this.setState({ relationData: values });
        let relValues = {
            type: "outgoing",
            relations: values
        };
        this.props.onRelationChange("outgoing", relValues);
    }
    handleDescriptionChange = (e) => {
        const value = e.target.value;
        if (value.length <= 2000) {
          this.setState({ description: value, descriptionError: false });
        } else {
          this.setState({ descriptionError: true });
        }
      };
    render() {
        const { entryType, entryTypesList, values, visible,descriptionError } = this.state
        console.log(values);
        let main = null;
        if (!isUndefined(entryTypesList)) {

            let options = entryTypesList.filter(eT => eT.systemType === "object").map(el => ({ value: el.type, label: el.name, key: el.type }));

            main = <Form name="basic" layout="vertical" onFinish={this.choiceET} autoComplete="off">
                <Form.Item name="entryType" label="Entry Type">
                    <Select showSearch style={{ width: "100%" }} options={options} />
                </Form.Item>
                <Button style={{ width: "100%" }} type="primary" htmlType="submit">OK</Button>
                <Button style={{ width: "100%" }} onClick={this.handleCancel}>Cancel</Button>
            </Form>
        }
        if (entryType) {
            main = <Form name="basic" layout="vertical" onFinish={this.createTask} initialValues={values} autoComplete="off">
                <Form.Item name="taskName" label="Task name" >
                    <Input/>
                </Form.Item>
                <Form.Item name="entryEdit_EntryId" label="Entry ID" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>
                <Form.Item name="entryEdit_Status" label="Status" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>
                <Form.Item name="name" label="Entry Name">
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Description"
                    validateStatus={descriptionError ? 'error' : ''}
                    help={descriptionError ? 'Description cannot exceed 2000 characters' : ''}
                    name="description"
                >
                    <Input.TextArea
                        onChange={this.handleDescriptionChange}
                        rows={6}
                    />
                </Form.Item>
                <AttributeForm properties={entryType.properties} />
                <Button style={{ width: "100%", marginTop: '10px' }} disabled={descriptionError}  type="primary" htmlType="submit">OK</Button>
                <Button style={{ width: "100%" }} onClick={this.handleCancel}>Cancel</Button></Form>
        }
        let modal = <Modal title="Entry edit" destroyOnClose={true} width={entryType ? "70%" : "40%"} open={visible} footer={false} onCancel={this.handleCancel} >
            {main}
        </Modal>
        return <>{modal}<Tooltip placement="leftTop" title="Entry edit">
            <EditOutlined onClick={(event) => this.showModal(event)} style={{ fontSize: '22px', marginLeft: '3px' }} />
        </Tooltip>
        </>
    }
}

export default EntryEdit;